import "./AppointmentsInjuryDetailsFormAddComponent.scss";
import CardComponent from "../../../../shared/components/card/CardComponent";
import {useParams} from "react-router-dom";
import ClientInjuryDetailsScreen from "../../../client-registration/client-injury-details/ClientInjuryDetailsScreen";
import BackComponent from "../../../../shared/components/back/BackComponent";
import React, {useCallback} from "react";

interface AppointmentsInjuryDetailsFormAddComponentProps {

}

const AppointmentsInjuryDetailsFormAddComponent = (props: AppointmentsInjuryDetailsFormAddComponentProps) => {
    const {appointmentId} = useParams();

    const handleBackNavigation = useCallback(() => {
        window.history.back();
    }, []);

    return (
        <div className={'appointments-injury-details-form-add-component appointment-form'}>
            <div className={'appointments-form-header'}>
                <BackComponent onClick={() => {
                    handleBackNavigation()
                }}/>
                {/*{appointmentDetails?.status === 'scheduled' && <>*/}
                {/*    <ButtonComponent onClick={handleRescheduleAppointment}>*/}
                {/*        Reschedule Appointment*/}
                {/*    </ButtonComponent>*/}
                {/*</>}*/}
            </div>
            <CardComponent>
                <ClientInjuryDetailsScreen mode={"add"} onNext={handleBackNavigation} appointmentId={appointmentId}/>
            </CardComponent>
        </div>
    );

};

export default AppointmentsInjuryDetailsFormAddComponent;
